import { render, staticRenderFns } from "./EditSection.vue?vue&type=template&id=5c566544&scoped=true"
import script from "./EditSection.vue?vue&type=script&lang=js"
export * from "./EditSection.vue?vue&type=script&lang=js"
import style0 from "./EditSection.vue?vue&type=style&index=0&id=5c566544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c566544",
  null
  
)

export default component.exports